<template>
  <div class="timeline">
    <h3 class="timeline__title" v-html="`${isAdmin ? `${currentUserProfile.firstName}'s` : 'Your' } Timeline`"/>
    <router-link v-if="isAdmin && currentUserProfile" :to="{ path: 'update-profile', query: { uid: currentUserProfile.uid }}">Profile</router-link>
    <div class="timeline__cols">
      <h2>Your Tasks</h2>
      <h2>Our Tasks</h2>
      <template v-for="taskGroup in timelineSteps">
        <div class="fill" :key="`${taskGroup.id}-fill1`" v-if="taskGroup.owner === 'admin'"/>
        <div class="task" :key="`${taskGroup.id}-task`">
          <h5 v-if="taskGroup.owner === 'admin'">Our Task</h5>
          <h5 v-if="taskGroup.owner === 'client'">Your Task</h5>
          <TimelineTask
            :consultationId="consultationId"
            :taskGroup="taskGroup"
            :showActions="true"
            />
        </div>
        <div class="fill" :key="`${taskGroup.id}-fill2`" v-if="taskGroup.owner === 'client'"/>
      </template>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapState } from 'vuex'
import timelineSteps from '@/library/timelineSteps'
import TimelineTask from '@/components/TimelineTask'

export default {
  name: 'Timeline',
  components: { TimelineTask },
  computed: {
    ...mapGetters([
      'allTasks',
      'currentUserProfile',
    ]),
    ...mapState([
      'isAdmin'
    ]),
    consultationId() {
      return this.currentUserProfile?.consultationId
    },
  },
  data() {
    return {
      timelineSteps
    }
  }
}
</script>

<style lang="scss" scoped>
.timeline {
  width: 100%;
  max-width: 60rem;
  margin: 0 auto;
  &__title {
    font-size: 2rem;
    font-weight: 300;
  }
  &__cols {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 10px;
    position: relative;
    margin: 20px 20px 40px;
    @media ($sm-down) {
      display: block;
      h2, .fill {
        display: none;
      }
      .task {
        position: relative;
        h5 {
          font-size: 10px;
          position: absolute;
          top: 10px;
          right: 30px;
          z-index: 100;
        }
      }
    }
    @media ($sm-up) {
      h5 {
        display: none;
      }
      &::before, &::after {
        content: '';
        width: 1px;
        height: 100%;
        position: absolute;
        left: 25%;
        top: 7rem;
        border-left: dashed 2px #ccc;
        z-index: -1;
      }
      &::after {
        left: 75%;
        top: 4rem
      }
    }


    > div {
      position: relative;
      flex: 1;
      min-height: 100px;
      h2 {
        margin-bottom: 2rem;
      }
    }
    &__your-tasks {
      margin-right: 2rem;
    }
    &__our-tasks {
      margin-top: 4rem;
      padding-top: 2rem;
      h2 {
        position: relative;
        top: -6rem;
      }
    }
  }
}
</style>